<template>
  <div class="active-consult">
    <div
      class="public-list-template"
      v-for="(data,index) in datas"
      :key="index"
      @click="goDetail(data.id)"
    >
      <div class="news-left">
        <!-- <img :src="data.img | filterB" alt v-if="data.img==null?false:true" /> -->
      </div>
      <div class="news-right">
        <p>{{data.title}}</p>
        <p>
          <!-- <span style="margin-right:.5rem;">浏览:{{data.sees}}</span>
          <span>点赞:{{data.praise}}</span>-->
          <span style="float:right;margin-right:.3rem">{{data.time|times}}</span>
        </p>
      </div>
    </div>

    <!-- <div class="next-url" @click="loadMore">---- 加载更多----</div> -->
  </div>
  <!-- 所有调用该表所传来的url 都应该是get -->
</template>

<script>
export default {
  data() {
    return {
      datas: [],
      url: "",
      pager: 1
    };
  },
  created: function() {
    this.render();
  },
  methods: {
    // loadMore() {
    //   this.pager++;
    //   this.render();
    // },
    render() {
    //   this.url = this.$route.query.url + "?pager=" + this.pager;
      // console.log(this.url);
      this.axios
        .get(`/api/Party/Activity?token=${sessionStorage.getItem('token')}`)
        .then(e => {
        console.log(e.data);
        
          if (e.data.code == 0) {
            this.datas = e.data.msg;
          } else {
            alert(e.data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    goDetail(newsid) {
      this.$router.push({
        path: "/publicDetail",
        query: { title: "三会一课资讯", id: newsid, dbnum: 3 }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.active-consult {
  .next-url {
    background: #fff;
    font-size: 0.3rem;
    text-align: center;
    line-height: 3;
  }
  padding-top: 1.1rem;
}
.public-list-template {
  font-size: 0.3rem;
  width: 94%;
  margin: 0 auto;
  display: flex;
  margin-bottom: 0.2rem;
  background: #fff;
  padding: 0.2rem 0;
  border-radius: 0.16rem;
  //   align-items: center;
  .news-right {
    width: 100%;
    margin-left: 0.2rem;
    p:nth-child(1) {
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      display: -webkit-box;
      margin-bottom: 0.3rem;
      line-height: 1.8;
    }
    p:nth-child(2) {
      border-top: 0.01rem solid #e6e6e6;
      padding-top: 0.2rem;
      color: #999999;
      font-size: 0.26rem;
    }
  }
  .news-left {
    img {
      width: 2.4rem;
      height: 2rem;
      margin-left: 0.2rem;
    }
  }
}
</style>
